import { Football, Lightning, Check, ArrowRight, ShieldCheck, Target, Scales, GoogleLogo } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { trackEvent } from "@/App";
import SEO from "@/components/SEO";
import PublicNav from "@/components/PublicNav";

function FeatureHeader() {
  return <PublicNav />;
}

function FeatureCTA({ onExplore }) {
  const handleGoogleLogin = () => {
    const r = window.location.origin + '/';
    window.location.href = '/api/auth/google/login';
  };
  return (
    <div className="text-center py-16 border-t border-[#262626]">
      <h2 className="font-heading text-3xl sm:text-4xl text-white uppercase mb-3">READY TO DOMINATE YOUR LEAGUE?</h2>
      <p className="text-sm text-[#a3a3a3] mb-6 max-w-lg mx-auto">Import your Sleeper leagues in seconds. No credit card required to start.</p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <Button onClick={() => { trackEvent("try_free_click"); window.location.href = "/"; }} className="h-11 px-8 btn-primary rounded-sm text-sm"><Lightning size={16} weight="bold" className="mr-2" />TRY FREE — NO SIGN UP</Button>
        <Button onClick={handleGoogleLogin} className="h-11 px-8 bg-white text-black font-bold text-sm rounded-sm hover:bg-gray-100">GO PRO — FROM $19.99/yr</Button>
      </div>
      <div className="flex items-center justify-center gap-6 mt-8 text-xs text-[#666]">
        <Link to="/features/trade-finder" className="hover:text-[#ccff00] no-underline">Trade Finder</Link>
        <Link to="/features/draft-room" className="hover:text-[#ccff00] no-underline">Draft Room</Link>
        <Link to="/features/trade-simulator" className="hover:text-[#ccff00] no-underline">Simulator</Link>
        <Link to="/features/roster-tools" className="hover:text-[#ccff00] no-underline">Roster Tools</Link>
      </div>
    </div>
  );
}

function Step({ num, title, desc }) {
  return (
    <div className="flex gap-4">
      <div className="w-10 h-10 shrink-0 bg-[#ccff00] text-black font-bold text-lg flex items-center justify-center rounded-sm">{num}</div>
      <div><h3 className="text-white font-semibold text-base mb-1">{title}</h3><p className="text-sm text-[#a3a3a3] leading-relaxed">{desc}</p></div>
    </div>
  );
}

function Benefit({ title, desc }) {
  return (
    <div className="border border-[#262626] bg-[#171717] p-5">
      <div className="flex items-center gap-2 mb-2"><Check size={16} weight="bold" className="text-[#ccff00]" /><h3 className="text-white font-semibold">{title}</h3></div>
      <p className="text-sm text-[#a3a3a3] leading-relaxed">{desc}</p>
    </div>
  );
}

export { FeatureHeader, FeatureCTA, Step, Benefit };
